<template>
  <v-container>
    <v-row>
      <v-col>
        <v-select
          type="string"
          :items="[
            { runType: 1, description: 'Initial' },
            { runType: 2, description: 'Royalty' }
          ]"
          item-text="description"
          item-value="runType"
          v-model="runType"
          label="Run Type"
          @input="refresh"
          :disabled="disabled"
        ></v-select>
        <v-select
          type="number"
          :items="runs"
          :item-text="
            item =>
              `${item.runId} ${
                item.amount ? ' - $' + item.amount.toFixed(2) : ''
              }`
          "
          item-value="runId"
          v-model="runId"
          label="Run ID"
          :loading="loading"
          @input="selected"
          :disabled="disabled"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    disabled: {
      type: Boolean
    }
  },
  name: "CommsRuns",
  data() {
    return {
      loading: false,
      current: 0
    };
  },
  computed: {
    ...mapFields("commissions", ["run.runId", "run.runType"]),
    ...mapState("commissions", ["runs"])
  },
  mounted() {
    // if (this.runs.length === 0)
    this.refresh();
  },
  methods: {
    ...mapActions("commissions", ["getCommissionRuns", "setRun"]),
    selected() {
      this.setRun({ runId: this.runId, runType: this.runType });
      this.$emit("runSelected", { runId: this.runId, runType: this.runType });
      this.$emit("blur", { runId: this.runId, runType: this.runType });
    },
    refresh() {
      let vm = this;
      vm.loading = true;
      this.getCommissionRuns(vm.runType).then(dataReturn => {
        vm.loading = false;
        let now = new Date();
        if (!vm.runType) vm.runType = dataReturn.currentRun.runType;
        if (!vm.runId) {
          vm.runId = dataReturn.currentRun.runId;
          vm.current = Math.max(
            ...vm.runs
              .filter(x => x.runType === vm.runType && new Date(x.dateTo) < now)
              .map(y => y.runId)
          );
        }
      });
    }
  }
};
</script>

<style scoped></style>
